import { Component, OnInit } from '@angular/core';
import { DocumentoService } from 'src/app/service/documento/documento.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  collapse: boolean = false;
  usuario:any;
  loading: boolean;
  adqMenu:boolean;
  provMenu:boolean;
  avatar:any;
  prov:any;
  foto : any;
  adq:any;
  constructor(private negociabesService: DocumentoService,) {

    this.usuario = JSON.parse(sessionStorage.getItem("UserActive"));
    this.prov = JSON.parse(sessionStorage.getItem("ProvActive"));
    this.adq = JSON.parse(sessionStorage.getItem("AdqActive"));
    this.foto = JSON.parse(sessionStorage.getItem("uploadFoto"));

    if(this.foto == null ){
      this.foto = this.usuario.Imagen;
    }

    if(this.prov != null){
      this.provMenu = true;
      this.negociabesService.provSwicht = true;
    }
    if(this.adq != null){
      this.adqMenu = true;
      this.negociabesService.adqSwicht = true;
    }
  }

  ngOnInit() {


    //this.avatar = 'http://drive.google.com/uc?export=view&id='+ JSON.parse(sessionStorage.getItem("Foto"));
  }
}
